var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFiltro01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.5 0h-30v362h-30v90h30v60h30v-60h30v-90h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.5 362v-362h-30v362h-30v90h30v60h30v-60h30v-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.5 0h-30v222h-30v90h30v200h30v-200h30v-90h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.5 0h-30v53.652h-30v90h30v368.348h30v-368.348h30v-90h-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFiltro01);
export default __webpack_public_path__ + "static/media/ico-filtro-01.c20dbcf7a8c0ac84933c03185f69e211.svg";
export { ForwardRef as ReactComponent };